import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CurveService } from 'src/app/shared/curve-service/curve.service';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-view-transactions',
    templateUrl: './view-transactions.component.html',
    styleUrls: ['./view-transactions.component.css'],
    standalone: false
})
export class ViewTransactionsComponent implements OnInit {

  role
  serverErrorMessages: string
  AllpaidTransactions
  paidTransactions=[]
 
  AllunpaidTransactions
  unpaidTransactions=[]
  expert:{}
  closeResult
  pdfLoading: boolean = false
  filterForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  })
  missingFields = false

  constructor(private loginService: LoginService, private expertService: ExpertService, private router : Router, private modalService: NgbModal, private datePipe: DatePipe) {
    this.getPaidTransacions();
    this.getUnpaidTransacions();
   }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.expert = res['user']
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getPaidTransacions(){
    this.expertService.getAllPaidTransaction().subscribe(
      res => {
       //console.log('got paid transactions', res)
        this.AllpaidTransactions = res
        this.paidTransactions = this.AllpaidTransactions
       //console.log(this.paidTransactions)
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  reset()
  {
    this.filterForm.reset();
    this.paidTransactions = this.AllpaidTransactions
    this.unpaidTransactions = this.AllunpaidTransactions
    
  }

  getUnpaidTransacions(){
    this.expertService.getAllUnpaidTransaction().subscribe(
      res => {
       //console.log('got unpaid transactions', res)
        this.AllunpaidTransactions = res
        this.unpaidTransactions = this.AllunpaidTransactions
       //console.log(this.unpaidTransactions)
      },
      err => {
       //console.log('error', err)
      }
    )
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  open(content) {
    // this.expert = expert
    ////console.log('got expert', this.expert)
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  sendInvoiceDateFilter(){
    const expertID  = this.expert['_id']
    
    const fullName = this.expert['fullName']
    const mailingAddress = this.expert['mailingAddress'];
    // console.log(this.expert)
    const startDate=this.filterForm.get('startDate').value
    const endDate=this.filterForm.get('endDate').value
    if (!startDate || !endDate) this.missingFields = true
    else {
      this.pdfLoading = true;
      this.expertService.sendInvoiceDateFilter(expertID, startDate, endDate,fullName,mailingAddress)
      .then(resp =>
        {
          if(resp.status === 500) throw new Error('gg')
          else return resp.arrayBuffer()
        }).then(resp => {
        const file = new Blob([resp], {type: 'application/pdf'});
        // process to auto download it
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = expertID + '_' + this.expert['fullName'] + '_' + this.datePipe.transform(startDate, 'yyyy-MM-dd') + 'to' + this.datePipe.transform(endDate, 'yyyy-MM-dd') + ".pdf";
        link.click();
        this.pdfLoading = false;
        this.filterForm.reset();
      }).catch(err => {
        console.log('errorrrr', err)
        alert('No transactions found! Please try other dates')
        this.pdfLoading = false;
      });
    }
    
  }

  filter()
  {
    const startDate= this.transformDate(this.filterForm.get('startDate').value)
    const endDate= this.transformDate(this.filterForm.get('endDate').value)
    let data1 = []
    let data2 = []
    for(let x of this.AllpaidTransactions)
    {
      var d = this.transformDate(x.createdAt)
      
      if(d>=startDate && d<=endDate)
        data1.push(x)
    }

    for(let y of this.AllunpaidTransactions)
    { 
      var e = this.transformDate(y.createdAt)
      // console.log(e, startDate, endDate);
      if(e>=startDate && e<=endDate)
      data2.push(y)
    }

    this.paidTransactions = data1
    this.unpaidTransactions = data2

    console.log(this.paidTransactions, this.unpaidTransactions)
  }

  
  clearDate(event) {
    event.stopPropagation();
    this.filterForm.get('startDate').setValue(null);
    this.filterForm.get('endDate').setValue(null);
  }

}
